import jwtDecode from 'jwt-decode';
import { AccessTokenDto } from '../../types';

const currentFeatures: string[] = [];

export const setFeaturesFromAccessToken = (accessToken?: string): void => {
	try {
		currentFeatures.splice(0);
		if (!accessToken) {
			return;
		}
		const tokenPayload = jwtDecode<AccessTokenDto>(accessToken);
		const features = tokenPayload.features;
		currentFeatures.push(...features);
	} catch (e) {
		console.error('error parsing features from access token', e);
	}
};

export const hasFeature = (item?: string): boolean => {
	return !item || currentFeatures.includes(item);
};
